/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { TriggerEvent, TriggerEvent$inboundSchema } from "./triggerevent.js";

export type ListTriggerEventsResult = {
  /**
   * The dispatch events for the trigger instance, most recent first.
   */
  events: Array<TriggerEvent>;
};

/** @internal */
export const ListTriggerEventsResult$inboundSchema: z.ZodMiniType<
  ListTriggerEventsResult,
  unknown
> = z.object({
  events: z.array(TriggerEvent$inboundSchema),
});

export function listTriggerEventsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListTriggerEventsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTriggerEventsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTriggerEventsResult' from JSON`,
  );
}
